import React, { useState } from 'react';
import './css/Future.css';
import rightsvg from "../assets/rightsvg.svg"
import leftarrowsvg from "../assets/leftarrowsvg.svg"
import { Link } from 'react-router-dom';

const Future = () => {
    const [selectedService, setSelectedService] = useState('CustomFurniture');

    const data = [
        {
            CustomFurniture: {
                Description: "Our master craftsmen create bespoke wooden furniture that combines traditional woodworking techniques with contemporary design. Each piece is handcrafted to perfectly match your style and space requirements.",
                svg: rightsvg,
                feature1: "Customized designs for your unique needs",
                feature2: "Premium hardwood selection",
                feature3: "Expert joinery and finishing"
            },
            InteriorWoodwork: {
                Description: "Transform your space with our comprehensive interior woodworking solutions. From custom cabinetry to architectural details, we create stunning wooden elements that enhance your interior's beauty and functionality.",
                svg: rightsvg,
                feature1: "Custom cabinetry and built-ins",
                feature2: "Wooden wall paneling and trim work",
                feature3: "Architectural woodwork details"
            },
            CommercialProjects: {
                Description: "We specialize in commercial woodworking projects that elevate business spaces. Our team delivers premium wooden installations that combine durability with sophisticated design for offices, restaurants, and retail spaces.",
                svg: rightsvg,
                feature1: "Office furniture and workstations",
                feature2: "Restaurant and retail fixtures",
                feature3: "Commercial-grade durability"
            }
        }
    ];

    const hoverdivcontent = "Experience the artistry of fine woodworking with Dhiman Wood Works.";

    return (
        <section className='future-main-div'>
            <div className='future-container-main'>
                <div className='future-container-main-content1'>
                    <div className='future-container-main-content1-content1'>
                        <h1 className='future-heading-para'> . MASTER CRAFTSMANSHIP</h1>
                        <h1 className='future-heading-main1'>Creating Timeless Wooden Masterpieces</h1>
                    </div>
                    <div className='future-container-main-content1-content2'>
                        <div className='map-select-content-div'>
                            {Object.keys(data[0]).map((service, index) => (
                                <div
                                    key={index}
                                    className={`service-item ${selectedService === service ? 'active' : ''}`}
                                    onClick={() => setSelectedService(service)}
                                >
                                    {service}
                                </div>
                            ))}
                        </div>
                        <div className='show-selected-content-div'>
                            <p className='service-description'>
                                {data[0][selectedService].Description}
                            </p>
                            <div className='service-features'>
                                <div className='feature-item'>
                                    <img src={data[0][selectedService].svg} alt="feature" />
                                    <p>{data[0][selectedService].feature1}</p>
                                </div>
                                <div className='feature-item'>
                                    <img src={data[0][selectedService].svg} alt="feature" />
                                    <p>{data[0][selectedService].feature2}</p>
                                </div>
                                <div className='feature-item'>
                                    <img src={data[0][selectedService].svg} alt="feature" />
                                    <p>{data[0][selectedService].feature3}</p>
                                </div>
                            </div>
                        </div>
                        <Link to="/services">
                            <button className='button-89-2'>Explore Our Services</button>
                        </Link>
                    </div>
                </div>
                <div className='future-container-main-content2'>
                    <div className='future-container-navigation-div'>
                        <div className='arrow-left'><img src={leftarrowsvg} alt="navigation arrow"/></div>
                        <p className='para-navigate-future'>Discover our signature woodworking techniques and craftsmanship.</p>
                        <div className='hover-content'>
                            <p>{hoverdivcontent}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Future;
